export default __webpack_public_path__ + "static/media/night.4c6dfe31.svg";